import { Platform } from "react-native"
import { useBoolVariation, useStringVariation } from "@/hooks/launchDarklyHooks"

/** LaunchDarkly flags driving the blocking upgrade gate. */
export const FORCE_UPGRADE_FLAGS = {
  required: "force-upgrade-required",
  requiredAndroid: "force-upgrade-required-android",
  title: "force-upgrade-title",
  message: "force-upgrade-message",
  buttonTitle: "force-upgrade-button-title",
} as const

export const FORCE_UPGRADE_DEFAULTS = {
  title: "We flipped the app",
  message:
    "A fresh look and smarter tools, with the same Backflip team behind every loan",
  buttonTitle: "Get the new app",
}

export interface ForceUpgradeState {
  required: boolean
  title: string
  message: string
  buttonTitle: string
}

/**
 * Remote kill-switch for the current app. iOS and Android each have their own
 * flag so they can be rolled out separately; web is never gated.
 */
export const useForceUpgrade = (): ForceUpgradeState => {
  const iosRequired = useBoolVariation(FORCE_UPGRADE_FLAGS.required, false)
  const androidRequired = useBoolVariation(
    FORCE_UPGRADE_FLAGS.requiredAndroid,
    false
  )
  const title = useStringVariation(
    FORCE_UPGRADE_FLAGS.title,
    FORCE_UPGRADE_DEFAULTS.title
  )
  const message = useStringVariation(
    FORCE_UPGRADE_FLAGS.message,
    FORCE_UPGRADE_DEFAULTS.message
  )
  const buttonTitle = useStringVariation(
    FORCE_UPGRADE_FLAGS.buttonTitle,
    FORCE_UPGRADE_DEFAULTS.buttonTitle
  )

  return {
    required:
      (Platform.OS === "ios" && iosRequired) ||
      (Platform.OS === "android" && androidRequired),
    title,
    message,
    buttonTitle,
  }
}
